<template>
  <div class="crud">
    <div class="notification">
      <notification-message />
    </div>

    <div class="updateListLocation">
      <v-btn color="red darken-1" outlined @click="fetchLocations" class="mr-2">
        {{ $t("crudLocation.updateListLocation") }}
      </v-btn>
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="red darken-1"
      ></v-progress-circular>
    </div>

    <!-- Start Array -->
    <div class="crudArray">
      <v-data-table
        :headers="headers"
        :items="locations"
        :search="search"
        :footer-props="{ showFirstLastPage: true }"
        sort-by="city"
      >
        <template v-slot:[`item.colorcircle`]="{ item }">
          <v-icon left :color="item.color"> mdi-circle </v-icon>
        </template>

        <template v-slot:[`item.hidden`]="{ item }">
          <v-switch v-model="item.hidden" @change="saveHidden(item)"></v-switch>
        </template>

        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{ $t("crudLocation.title") }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field
              id="search-location"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('crudLocation.searchLocation')"
              single-line
              hide-details
              color="grey"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="button-new-location"
                  color="red darken-1"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ $t("crudLocation.new") }}
                </v-btn>
              </template>
              <!-- Start Form -->
              <v-card v-if="editedItem">
                <v-form ref="form" v-model="valid">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-text-field
                        id="location-city"
                        v-model="editedItem.city"
                        :label="$t('crudLocation.titleLocation')"
                        :rules="inputText"
                        required
                        color="grey"
                      >
                      </v-text-field>
                      <v-text-field
                        v-model="editedItem.color"
                        :label="$t('crudLocation.colorLocation')"
                        color="grey"
                        disabled
                      >
                      </v-text-field>
                      <v-color-picker
                        id="location-color"
                        v-model="editedItem.color"
                        elevation="0"
                        style="border: solid rgb(212, 212, 212) 1px"
                        mode="hexa"
                      >
                      </v-color-picker>
                      <v-text-field
                        id="location-city"
                        v-model="editedItem.countryCode"
                        :label="$t('crudLocation.titleLocation')"
                        :rules="inputText"
                        required
                        color="grey"
                      >
                      </v-text-field>
                      <v-text-field
                        id="location-city"
                        v-model="editedItem.address"
                        :label="$t('crudLocation.address')"
                        color="grey"
                      >
                      </v-text-field>
                      <v-text-field
                        id="location-city"
                        v-model="editedItem.zipCode"
                        :label="$t('crudLocation.zipCode')"
                        color="grey"
                        counter
                      >
                      </v-text-field>
                      <v-switch
                        :label="$t('crudLocation.hidden')"
                        v-model="editedItem.hidden"
                      >
                      </v-switch>
                    </v-container>
                    <v-row>
                      <v-col cols="7"></v-col>
                      <v-col cols="5"
                        ><p>
                          <i>{{ $t("crudLocation.required") }}</i>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="close">
                      {{ $t("crudLocation.cancel") }}
                    </v-btn>
                    <v-btn
                      id="button-save-location"
                      color="red darken-1"
                      text
                      @click="save"
                      :disabled="!valid"
                    >
                      {{ $t("crudLocation.save") }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
              <!-- End Form -->
            </v-dialog>
            <!-- Start Dialog Delete -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card v-if="editedItem" class="card-delete">
                <v-card-title class="headline">{{
                  $t("crudLocation.confirmDelete")
                }}</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="F44336" text @click="closeDelete">{{
                    $t("crudLocation.cancel")
                  }}</v-btn>
                  <v-btn
                    id="button-delete-location-confirm"
                    color="F44336"
                    text
                    @click="deleteItemConfirm"
                    >{{ $t("crudLocation.ok") }}</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- End Dialog Delete -->
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="button-update-location" @click="editItem(item)">
            mdi-pencil
          </v-icon>
        </template>
        <template v-slot:no-data>
          {{ $t("crudLocation.noData") }}
        </template>
      </v-data-table>
    </div>
    <!-- End Array -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NotificationMessage from "@/components/components-base/notification/NotificationMessage.vue";
import LoginWdg2 from "@/components/components-base/LoginWdg2.vue";
import i18n from "@/i18n";

export default {
  components: {
    NotificationMessage,
    LoginWdg2,
  },
  data: () => ({
    search: "",
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: i18n.t("crudLocation.hId"),
        value: "id",
        align: "center",
        sortable: false,
      },
      { text: i18n.t("crudLocation.hCity"), value: "city", sortable: true },
      {
        text: i18n.t("crudLocation.hCountryCode"),
        value: "countryCode",
        sortable: true,
      },
      {
        text: i18n.t("crudLocation.hColor"),
        value: "colorcircle",
        sortable: false,
      },
      {
        text: i18n.t("crudLocation.hidden"),
        value: "hidden",
        sortable: true,
      },
      {
        text: i18n.t("crudLocation.hActions"),
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    loading: false,
    valid: true,
    inputText: [
      (v) =>
        /^[A-Za-zàâçéèêëîïôûùüÿñæœ .-0-9/(*)]*$/i.test(v) ||
        i18n.t("errorFrontEnd.specialCharacters"),
    ],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? i18n.t("crudLocation.newLocation")
        : i18n.t("crudLocation.updateLocation");
    },
    ...mapGetters("locationModule", { locations: "getLocations" }),
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  mounted() {},
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("locationModule", [
      "loadLocations",
      "addLocation",
      "editLocation",
      "deleteLocation",
      "fetchLocationsDG2",
    ]),
    ...mapActions("notificationModule", ["showNotification"]),
    initialize() {
      this.loadLocations();
    },
    editItem(item) {
      this.editedIndex = this.locations.indexOf(item);
      this.editedItem = item;
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.locations.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.deleteLocation(this.editedItem);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.editedItem = {};
      this.editedIndex = -1;
      this.$refs.form.reset();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.editedItem = this.defaultItem;
      this.editedIndex = -1;
      this.$refs.form.reset();
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.editLocation(this.editedItem);
        } else {
          this.addLocation(this.editedItem);
        }
        this.close();
        this.$refs.form.reset();
      }
    },
    saveHidden(item) {
      this.editLocation(item);
    },
    // fetch locations from webservice DG2
    async fetchLocations(value) {
      this.loading = true;
      await this.fetchLocationsDG2({ logInUser: value });
      this.loading = false;
      await this.loadLocations();
    },
  },
};
</script>

<style>
.crud {
  width: 100%;
}

.crudArray {
  margin: 3rem auto;
  width: 80%;
}

.notification {
  width: 100%;
  position: absolute;
  padding: 0 1.5rem;
}

.login-wdg2 {
  position: absolute;
  width: 30%;
  z-index: 3;
}

.updateListLocation {
  display: flex;
  justify-content: center;
  padding: 2rem 0 0 0;
}
</style>
